import type {Icon} from '@primer/octicons-react'
import {isLazyOcticonName, octiconComponent} from '@github-ui/lazy-octicon'

const toTitleCase = (str: string) => {
  return `${str
    .toLowerCase()
    .split('-')
    .map(function (word) {
      return word.charAt(0).toUpperCase() + word.slice(1)
    })
    .join('')}Icon`
}

/**
 * Looks up a Primer octicon by kebab-case name (e.g. `'shield-check'`) and
 * returns a component that lazily loads it (code-split), or `undefined` if the
 * name is not a recognized octicon. Callers avoid importing the entire octicons
 * set up front.
 */
export const getPrimerIcon = (name: string = ''): Icon | undefined => {
  const titleCaseName = toTitleCase(name)
  return isLazyOcticonName(titleCaseName) ? octiconComponent(titleCaseName) : undefined
}
